import React from 'react'

interface SectionCardProps {
  title: string
  subtitle?: string
  actions?: React.ReactNode
  className?: string
  children: React.ReactNode
}

export const SectionCard: React.FC<SectionCardProps> = ({ title, subtitle, actions, className = '', children }) => {
  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <h3 className="text-sm font-bold uppercase tracking-wider text-text-secondary">{title}</h3>
          {subtitle && <p className="mt-0.5 text-xs text-text-secondary/80">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
      </div>
      {children}
    </div>
  )
}
